import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Collapse from '@material-ui/core/Collapse';
import { useDrawerProvider } from "../providers/DrawerContext";
import MenuItems from "./Menu/Items";
import { useMenuProvider } from "../providers/MenuContext";
import Loading from "./Loading/Loading";
import { useCognitoProvider } from "../providers/CognitoContext";

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    marginTop: drawer => drawer.barHeight,
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(3),
  },
  subMenuContainer: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  loadingContainer: {
    height: '100vh',
    color: 'rgba(255,255,255,0.7)',
    '& .MuiCircularProgress-colorPrimary': {
      color: 'rgba(255,255,255,0.7)',
    },
  },
}));

export const Menu = ({ mobileBreakpoint, updateRoute }) => {

  const { state } = useDrawerProvider();
  const classes = useStyles(state);
  const nameOfOpenSubMenu = 'menu-item';
  const [open, setOpen] = useState([]);
  const { routes, loading } = useMenuProvider();
  const { state: cognitoState } = useCognitoProvider();

  useEffect(() => {
    const menuOpenAlloc = routes.map(route => route?.submenu?.length === 0 ? 0 : 1);
    setOpen(menuOpenAlloc);
  }, []);

  return (
    loading
      ? <Grid container alignItems='center' justifyContent='center' className={classes.loadingContainer}>
          <Loading />
        </Grid>
      : <List className={classes.root} disablePadding>
        {
          routes.map((route, index) => {
            const isOpen = open[index];
            if ((route.hideFromImpersonated && cognitoState.impersonated) || (route.hideFromImpersonated && cognitoState.admin === false))
              return <></>;
            return <React.Fragment key={"fragment_" + route.path}>
              <MenuItems
                index={index}
                open={open}
                setOpen={setOpen}
                route={route}
                isParentOfSubmenu={route.submenu ? true : false}
                mobileBreakpoint={mobileBreakpoint}
                updateRoute={updateRoute}
                nameOfOpenSubMenu={nameOfOpenSubMenu}
              />
              {
                route.submenuBuffer
                &&
                <Collapse
                  key={"collapse_" + route.path}
                  in={state.openDesktop ? isOpen : true}
                  style={{ paddingBottom: index === routes.length - 1 ? 16 : 0 }}
                >
                  <List className={classes.subMenuContainer}>
                    {route.submenuBuffer.map(sub => (
                      <MenuItems
                        key={sub.path}
                        index={index}
                        open={open}
                        setOpen={setOpen}
                        route={sub}
                        isSubMenu={true}
                        updateRoute={updateRoute}
                        mobileBreakpoint={mobileBreakpoint}
                        nameOfOpenSubMenu={nameOfOpenSubMenu}
                      />
                    ))}
                  </List>
                </Collapse>
              }
            </React.Fragment>
          })
        }
      </List>
  );
}

export default Menu;
